import { render, staticRenderFns } from "./Updateziliao.vue?vue&type=template&id=15f4df58&scoped=true"
import script from "./Updateziliao.vue?vue&type=script&lang=js"
export * from "./Updateziliao.vue?vue&type=script&lang=js"
import style0 from "./Updateziliao.vue?vue&type=style&index=0&id=15f4df58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4df58",
  null
  
)

export default component.exports